import React from "react";
import TermsWrap from "./TermsWrap";

function Terms(props) {
    return (
        <>
            <TermsWrap/>
        </>
    )
}

export default Terms;
